import { createLucideIcon } from "lucide-react"

/** Dooey mark as a Lucide-compatible icon */
export const DooeyIcon = createLucideIcon("DooeyIcon", [
  [
    "path",
    {
      key: "dooey-spark",
      d: "M9.6667 3.6667a3.3 3.3 0 1 1 4.6667 4.6667 3.3 3.3 0 0 1-4.6667-4.6667",
      fill: "currentColor",
      stroke: "none",
    },
  ],
  [
    "path",
    {
      key: "dooey-body",
      d: "M11.8293 13.2573 8.3333 9.7613a3.3 3.3 0 1 0-4.6667 4.6667l6 6a3.3 3.3 0 0 0 4.6667 0l6-6a3.3 3.3 0 1 0-4.6667-4.6667z",
      fill: "currentColor",
      stroke: "none",
      fillRule: "evenodd",
      clipRule: "evenodd",
    },
  ],
])
